var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningYellow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04023 2.37836C9.32868 2.20028 9.661 2.10596 10 2.10596C10.339 2.10596 10.6713 2.20028 10.9598 2.37836C11.2482 2.55645 11.4815 2.81128 11.6333 3.11435L17.5572 14.9621C17.6964 15.2406 17.7622 15.5502 17.7481 15.8612C17.7341 16.1721 17.6409 16.4744 17.4773 16.7392C17.3137 17.0041 17.0851 17.2227 16.8132 17.3744C16.5414 17.5261 16.2353 17.6058 15.924 17.606H4.07644C3.76513 17.6058 3.45863 17.5261 3.18678 17.3744C2.91493 17.2227 2.68635 17.0041 2.52272 16.7392C2.3591 16.4744 2.26586 16.1721 2.25185 15.8612C2.23784 15.5502 2.30353 15.2407 2.44269 14.9623L8.36633 3.11498C8.51823 2.81192 8.75177 2.55645 9.04023 2.37836Z",
    fill: "#FEB11F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.95142C10.4142 6.95142 10.75 7.2872 10.75 7.70142V10.9325C10.75 11.3467 10.4142 11.6825 10 11.6825C9.58579 11.6825 9.25 11.3467 9.25 10.9325V7.70142C9.25 7.2872 9.58579 6.95142 10 6.95142Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23019 13.3938C9.43433 13.1896 9.71119 13.075 9.99988 13.075C10.2886 13.075 10.5654 13.1896 10.7696 13.3938C10.9737 13.5979 11.0884 13.8748 11.0884 14.1635C11.0884 14.4521 10.9737 14.729 10.7696 14.9331C10.5654 15.1373 10.2886 15.252 9.99988 15.252C9.71119 15.252 9.43433 15.1373 9.23019 14.9331C9.02606 14.729 8.91138 14.4521 8.91138 14.1635C8.91138 13.8748 9.02606 13.5979 9.23019 13.3938ZM9.99988 14.175C10.0029 14.175 10.0059 14.1737 10.008 14.1716C10.0102 14.1694 10.0114 14.1665 10.0114 14.1635C10.0114 14.1604 10.0102 14.1575 10.008 14.1553C10.0059 14.1532 10.0029 14.152 9.99988 14.152C9.99684 14.152 9.99391 14.1532 9.99176 14.1553C9.9896 14.1575 9.98839 14.1604 9.98839 14.1635C9.98839 14.1665 9.9896 14.1694 9.99176 14.1716C9.99391 14.1737 9.99684 14.175 9.99988 14.175Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.22207056.svg";
export { ForwardRef as ReactComponent };